// EDIT BY ALI FOR DARK MODE - Updated NarrativeCard to use theme colors
import styled from "@emotion/styled";
import {Card, Typography} from "@mui/material";

styled(Typography)(() => ({
  fontWeight: 700,
  fontSize: 16,
}));

const CardBoundary = styled(Card)(({ theme }) => ({
  border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(88, 89, 91, 0.2)"}`,
  borderRadius: "8px",
  width: "500px",
  padding: "15px",
  transition: "transform 0.15s ease-in-out",
  backgroundColor: theme.palette.mode === "dark" ? "#1E1E1E" : undefined,
  color: theme.palette.mode === "dark" ? "#FFFFFF" : undefined,
  "&:hover": {
    // transform: "scale3d(1.01, 1.01, 1)",
    // background: "#fafafa"
  },
}));

export const NarrativeCard = (props) => {
  const {description} = props

  return (
    <CardBoundary variant="outlined" sx={{mb: "10px"}}>
      {description}
    </CardBoundary>
  )
}